<template>
    <ul class="w-full flex flex-col space-y-3" v-animate.stagger>
        <slot />
    </ul>
</template>

<script setup lang="ts"></script>
